import { DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { _parseDate } from "~/lib/localize.js";

export const DayNavigator = ({
  history,
  base_url = "/dailyreport/",
  isFuture = false,
}) => {
  const { allDays, activeDay } = useSelector((state) => state.days);

  const [prev, setPrev] = useState(null);
  const [next, setNext] = useState(null);

  useEffect(() => {
    // find index and set previous and next
    if (activeDay && allDays) {
      let newPrev = null;
      let newNext = null;
      let found = false;

      // first sort and filter
      let days = allDays;
      const today = new Date();
      today.setHours(0, 0, 0, 0); // normalize to midnight

      if (isFuture) {
        // only future days
        days = allDays.filter((d) => {
          const dayDate = new Date(d.datum);
          dayDate.setHours(0, 0, 0, 0);
          return dayDate >= today;
        });
      } else {
        // only past days
        days = allDays.filter((d) => {
          const dayDate = new Date(d.datum);
          dayDate.setHours(0, 0, 0, 0);
          return dayDate <= today;
        });
      }

      // sort by date ascending
      days.sort((a, b) => new Date(a.datum) - new Date(b.datum));
      days.some((day) => {
        if (found) {
          newNext = day;
          return true;
        }

        // iterate towards next day
        if (day.dag_id === activeDay.dag_id) {
          found = true;
        } else {
          newPrev = day;
        }
      });

      setPrev(newPrev);
      setNext(newNext);
    }
  }, [allDays, activeDay]);

  const button = (day, icon) =>
    day && (
      <Button icon={icon} onClick={() => history.push(base_url + day.dag_id)}>
        {_parseDate(day.datum, { month: "2-digit", day: "2-digit" })}
      </Button>
    );

  if (!activeDay) return null;
  if (!allDays) return null;

  return (
    <div className="row" style={{ gap: 4, marginRight: 6 }}>
      {button(prev, <DoubleLeftOutlined />)}
      {button(next, <DoubleRightOutlined />)}
    </div>
  );
};
